"use clent";

import React from "react";
import "./styles.css";
import "../common.css";

export const AboutBlock = ({
	backgroundColor = "#141414",
	borderRadius = 0,
	textColor = "#fff",
}) => {
	return (
		<div
			className="feature__wrapper"
			style={{
				background: backgroundColor,
				borderRadius: borderRadius,
				marginTop: borderRadius ? borderRadius * -1 : 0,
				marginBottom: borderRadius ? borderRadius * -1 : 0,
				position: borderRadius ? "relative" : "static",
				color: textColor,
			}}
		>
			<div className="container">
				<h2 className="about__title">
					О проекте
					<img src="/img/boostpad.png" alt="" />
				</h2>

				<div className="about__grid">
					<div className="about__column about__column--left">
						<div className="about__info">
							<div className="about__subtitle">Бренд</div>
							<div>BoostPad</div>
						</div>

						<div className="about__info">
							<div className="about__subtitle">Индустрия</div>
							<div>
								Web3, Launchpad, Криптовалюты и блокчейн (Crypto & Blockchain)
							</div>
						</div>

						<div className="about__info">
							<div className="about__subtitle">Релиз</div>
							<div>2024</div>
						</div>

						{/* <div className="about__info">
							<div className="about__subtitle">Cсылка</div>
							<div>
								<a
									href="http://contactlinklinklink@link.com"
									target="_blank"
									rel="noreferrer"
								>
									contactlinklinklink@link.com
								</a>
							</div>
						</div> */}
					</div>
					<div className="about__column">
						<div className="about__info">
							<div className="about__subtitle">О проекте</div>
							<div>
								Крипта — мир финансовых инструментов будущего. У каждого
								стартапа в сфере криптовалют свой подход, единых стандартов пока
								не существует. Поэтому сейчас 9 из 10 проектов на этом рынке
								слишком сложны и запутаны. Мы применили весь свой дизайнерский и
								продуктовый опыт, чтобы создать понятный, удобный и
								функциональный интерфейс для сложного криптопроекта — лаунчпада
								BoostPad.
							</div>
						</div>

						<div className="about__info">
							<div className="about__subtitle">Задачи</div>
							<div>
								<ul>
									<li>
										Провести полное исследование рынка подобных проектов и очень
										быстро сделать первую версию лаунчпада.
									</li>
									<li>
										Сделать лаунчпад криптовым, технологичным, современным,
										ярким.
									</li>
									<li>
										Спроектировать процесс покупки и получения токенов таким
										образом, чтобы сделать его простым и понятным для всех
										категорий пользователей.
									</li>
								</ul>
							</div>
						</div>

						<div className="about__info">
							<div className="about__subtitle">Решение</div>
							<div>
								Как правило, лаунчпады являются частью более крупных проектов,
								из-за чего часто теряются на фоне остальных продуктов. Отличие
								именно этого проекта в том, что мы создали отдельную платформу,
								без лишних наворотов. Сфокусировались только на лаунчпаде. Мы
								поставили цель решить одну конкретную задачу одним продуктом -
								этого пока не хватает на рынке криптовалют. Кроме того, мы
								стремились сделать его настолько интуитивно понятным, чтобы даже
								неподготовленный пользователь мог проанализировать проект и
								принять участие в лаунчпаде. И у нас это получилось!
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
